module.exports = __webpack_public_path__ + "static/media/elephant_sharpen-min.46281377.jpg";